<script>
    import { get } from 'svelte/store';
    import t from '../../translations/translator.js';
	import { getAllGames } from '../stores/GameStore.js';
    import Section from "../controls/Section.svelte";
    import Label from "../controls/LabelSetting.svelte";
    import ButtonDefault from "../controls/ButtonDefault.svelte";
    import {userId} from "../stores/UserStore.js";
    import { msgBox, showMsgBox, handlePositive, handleNegative } from "../stores/msgBox.js";
    import MsgBoxYesNo from '../msgboxes/MsgBoxYesNo.svelte';
    import { Sections } from "../../lib/nav.js";

	export let id;

	const games = getAllGames();
	const game = games.find(g => g.id === +id); 

    export let onNavigate = (section, params = {}) => {};

	function handleAdd() {
		console.log('Add to account:', game.id);
	}

	function handleCancel() {
		console.log('Go back');
	}

    function addGameToAccount() {
        const data = { userid: get(userId), gameid: game.id };
        console.log('data: ' + get(userId));
        const csrfToken = localStorage.getItem("csrfToken");
        console.log('csrf: ' + csrfToken);
        fetch('https://www.deckblox.app/rest/addGameForUser', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken,
        },
        body: JSON.stringify(data)
        })
        .then((response) => response.json())
        .then((data) => {
            if(data.error) {
                showMsgBox( t("GameInfo.msg.addgame_failed_title"),
                            t("GameInfo.msg.addgame_failed_body", data.error),
                            null,null);
            } else {
                console.log('Game Created!');
                showMsgBox( t("GameInfo.msg.addgame_success_title"),
                            t("GameInfo.msg.addgame_success_body"),
                            null,null);
                // navigate
                if(data.id) {
                    onNavigate(Sections.GAMES_SETTINGS, {newUserGameId: data.id});
                } else {
                    onNavigate(Sections.GAMES_OVERVIEW);
                }
                
            }
        })
        .catch((error) => {
            console.error('Error updating user:', error);
            showMsgBox( t("GameInfo.msg.addgame_failed_title"),
                            t("GameInfo.msg.addgame_failed_body", error),
                            null,null);
        });      
    }

    function goToAddGames() {
        onNavigate(Sections.GAMES_ADD_NEW);  
    }
</script>

<div class="space-y-6 p-4 text-left">
	<div class="flex items-center space-x-4">
		<img src={game.image} alt={game.name} class="w-32 h-32 object-cover rounded-lg" />
		<h1 class="text-3xl font-bold">{game.name}</h1>
	</div>

    <Section title="{t("GameInfo.label_description")}" subtitle={game.description} hasContent={false} />

    <Section title="{t("GameInfo.label_game_info")}" subtitle="">
        <div class="space-y-4">
            <div class="flex items-center space-x-4">
                <Label text={t("GameInfo.label_game_info_participation_type")}/>
                <Label text={game.infoParticipationType} bold full_width />
            </div>
            <div class="flex items-center space-x-4">
                <Label text={t("GameInfo.label_game_info_participation_method")}/>
                <Label text={game.infoParticipationMethod} bold full_width />
            </div>
            
        </div>
    </Section>

	<!-- Buttons row -->
    <div class="flex justify-end space-x-4 max-w-3xl">
        <ButtonDefault
        text={t("back")}
        onClick={goToAddGames}
        secondary
        />
        <ButtonDefault
        text={t("GameInfo.label_add_game")}
        onClick={addGameToAccount}
        />
    </div>

</div>


<MsgBoxYesNo />